import { call, put } from 'redux-saga/effects';

import api from 'api';
import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { openModal } from 'store/modals/actions';
import { resumeSubscription } from 'store/subscriptions/actions';
import { checkAllResumedSubscriptions } from 'store/subscriptions/helpers';

import { RENEW_SUCCESS_SCREEN_ID } from 'constants/analytics';

import { trackScreenLoadCancelOffer } from 'services/Analytics';

import { ModalName } from 'modals/types';

import { getRequestResumeSubscriptionErrorModalData, getResumeSuccessModalData } from 'helpers/subscriptions';

import { pollGetSubscriptions } from './pollGetSubscriptions';
import { handleAuthError } from './utils';

export function* requestResumeSubscription({ payload }: ReturnType<typeof resumeSubscription>) {
    try {
        yield put(
            openModal(ModalName.WithLoaderModal, {
                title: 'subscription.waitingModal.updatingPlan.title',
                img: null,
            })
        );
        yield call(api.subscriptions.resumeSubscription, {
            id: payload.external_id,
            provider: payload.provider,
        });

        const result: ISubscriptionWellfunnel[] = yield call(
            pollGetSubscriptions,
            checkAllResumedSubscriptions(payload.external_id)
        );

        const currentSubscription: ISubscriptionWellfunnel | undefined = result.find(
            ({ external_id }: ISubscriptionWellfunnel) => external_id === payload.external_id
        );

        if (currentSubscription) {
            yield call(trackScreenLoadCancelOffer, {
                screenId: RENEW_SUCCESS_SCREEN_ID,
                eventLabel: { subscription_id: payload.external_id },
            });

            yield put(
                openModal(
                    ModalName.SuccessModal,
                    getResumeSuccessModalData(currentSubscription.cancelled_at ?? currentSubscription.expired_date)
                )
            );
        }
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        yield put(
            openModal(ModalName.RetryErrorModal, {
                ...getRequestResumeSubscriptionErrorModalData([payload.external_id]),
                retryAction: () => resumeSubscription(payload),
            })
        );

        console.error(error);
    }
}
